/**
 * @import { Cruise } from "../types/cruise"
 * @import { Port } from "../types/port"
 * @import { ItineraryDayGroup } from "../types/itinerary-day-group"
 */

/**
 * @param {Port | undefined} port
 * @returns {string}
 */
export function formatPortName(port, delimiter = ', ') {
  return port ? [port.name, port.country].filter(Boolean).join(delimiter) : '';
}

/**
 * @param {Cruise | undefined} cruise
 * @returns {ItineraryDayGroup[]}
 */
export function groupItineraryDays(cruise) {
  /** @type {Map<string, ItineraryDayGroup>} */
  const groups = new Map();
  cruise?.days.forEach((day) => {
    const group = groups.get(day.dayNumber);
    if (group) {
      group.ports.push(day.port);
      group.excursions.push(...(day.excursions ?? []));
    } else {
      const { port, ...newGroup } = day;
      groups.set(day.dayNumber, { ...newGroup, ports: [port], excursions: newGroup.excursions?.slice() ?? [] });
    }
  });

  // values preserves insertion order
  return Array.from(groups.values());
}
